<template>
  <div class="pass-rewards-card -skeleton">
    <div class="pass-info">
      <div class="pass-img"></div>
      <div class="pass-details">
        <div class="pass-title"></div>
      </div>
    </div>

    <div class="pass-reward">
      <div class="reward-status" />
      <div class="reward-status-meter" />
    </div>
    <div class="reward-details"></div>
  </div>
</template>

<script setup lang="ts"></script>
